import { store } from "../../../../..";
import {
    globalActions,
    selectSetting,
} from "../../../../../features/global/globalSlice";
import { tournamentManagementActions } from "../../../../../features/tourneymgmt/tournamentManagementSlice";
import { getOrders } from "../../../../../lib/api";

export const TournamentRegistrationsLoader = async () => {
    const promises = [];
    const tournaments = store.getState().tournamentmanagement.tournaments;
    const masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;

    !tournaments.length &&
        promises.push(
            store.dispatch(tournamentManagementActions.getTournaments()),
        );

    !masterTournaments.length &&
        promises.push(
            store.dispatch(tournamentManagementActions.getMasterTournaments()),
        );

    const { settings } = store.getState().global;

    !settings.length && (await store.dispatch(globalActions.getSettings()));

    const currentYear = selectSetting(
        store.getState(),
        "wibb_current_league_year",
    )?.setting;

    const [{ orders }] = await Promise.all([
        getOrders(parseInt(currentYear)),
        ...promises,
    ]);

    return {
        orders,
    };
};
